// extracted by css-extract-rspack-plugin
export default {"text":"error-dialog-module__text___VpYhP","dismissButton":"error-dialog-module__dismissButton___McP2w"};